import { createStore } from 'vuex';
import VuexPersistence from 'vuex-persist';
import SecureLS from 'secure-ls';

import modules from './modules';

const ls = new SecureLS({ isCompression: false });

const vuexLocal = new VuexPersistence({
  storage: {
    getItem: (key) => ls.get(key),
    setItem: (key, value) => ls.set(key, value),
    removeItem: (key) => ls.remove(key),
    length: () => 0,
    clear: () => {},
    key: () => null,
  },
  reducer: (state) => ({
    currentUser: {
      isLoggedIn: state.currentUser.isLoggedIn,
      user: state.currentUser.user,
    },
    sidebar: {
      collapsed: state.sidebar.collapsed,
    },
  }),
});

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules,
  plugins: [vuexLocal.plugin],
});
